/* ─── Component registry: name → React component ─── */

import type { ComponentType } from 'react';

import { ArtifactRow, ArtifactColumn, ArtifactSideBySide, ArtifactList, ArtifactPaginated, ArtifactFloating, ArtifactSpacer, ArtifactColorBlock } from './components/Layout';
import { ArtifactScribble } from './components/Scribble';
import {
  ArtifactText,
  ArtifactImage,
  ArtifactIcon,
  ArtifactDivider,
  ArtifactMarkdown,
  ArtifactCode,
  ArtifactTextConsole,
} from './components/Display';
import {
  ArtifactTable,
  ArtifactPlotlyFigure,
  ArtifactMetricCard,
  ArtifactSummary,
} from './components/DataViz';
import {
  ArtifactButton,
  ArtifactTextField,
  ArtifactCheckbox,
  ArtifactPicker,
  ArtifactSlider,
  ArtifactButtonRow,
} from './components/Interactive';
import { ArtifactCard, ArtifactFramed, ArtifactModal, ArtifactTabs } from './components/Containers';
import { ArtifactHTML } from './components/HTMLEscape';
import { ArtifactThreeScene } from './components/ThreeScene';
import { ArtifactSvgScene } from './components/SvgScene';
import { ArtifactProgressBar } from './components/ProgressBar';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const COMPONENT_REGISTRY: Record<string, ComponentType<any>> = {
  // Layout
  Row: ArtifactRow,
  Column: ArtifactColumn,
  SideBySide: ArtifactSideBySide,
  List: ArtifactList,
  Paginated: ArtifactPaginated,
  Floating: ArtifactFloating,
  Spacer: ArtifactSpacer,
  ColorBlock: ArtifactColorBlock,


  // Display
  Text: ArtifactText,
  Image: ArtifactImage,
  Icon: ArtifactIcon,
  Divider: ArtifactDivider,
  Markdown: ArtifactMarkdown,
  Code: ArtifactCode,
  TextConsole: ArtifactTextConsole,

  // Data visualization
  Table: ArtifactTable,
  PlotlyFigure: ArtifactPlotlyFigure,
  MetricCard: ArtifactMetricCard,
  Summary: ArtifactSummary,

  // Interactive
  Button: ArtifactButton,
  TextField: ArtifactTextField,
  CheckBox: ArtifactCheckbox,
  ChoicePicker: ArtifactPicker,
  Slider: ArtifactSlider,
  ButtonRow: ArtifactButtonRow,

  // Containers
  Card: ArtifactCard,
  Framed: ArtifactFramed,
  Modal: ArtifactModal,
  Tabs: ArtifactTabs,

  // Feedback
  ProgressBar: ArtifactProgressBar,

  // 3D
  ThreeScene: ArtifactThreeScene,

  // SVG
  SvgScene: ArtifactSvgScene,

  // Scribble
  Scribble: ArtifactScribble,

  // Escape hatch
  HTML: ArtifactHTML,
};
